// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StaffPage .grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 32px;
  max-width: 1000px;
  margin: 0 auto 0 auto;
}

@media (max-width: 600px) {
  .StaffPage .grid {
    grid-template-columns: 1fr;  
  }
}

.StaffPage .grid > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.StaffPage .review {
  position: relative;
  max-width: 380px;
  text-align: center;
}

.StaffPage .review i {
  left: 0;
  position: absolute;
  color: var(--dark);
  opacity: 0.2;
  font-size: 3em;
}

.staffHero {
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 32px;
}

.staffBottom {
  text-align: center;
  width: calc(100% + 128px);
  margin-left: -64px;
  background-color: var(--light);
  box-shadow: var(--box-shadow);
  padding: 32px;
  margin-bottom: 32px;
}

.staffHero h4 {
  margin-top: 0px;
  margin-bottom: 40px;
}

.staffHero p {
  margin: 4px;
}

.staffBottom p {
  font-size: 1.2em;
  margin: 0 auto;
  margin-bottom: 16px;
  max-width: 260px;
  text-align: center;
}

@media (max-width: 950px) {
  .staffBottom {
    width: calc(100% + 40px);
    margin-left: -20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Staff.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,wBAAwB;IACxB,kBAAkB;EACpB;AACF","sourcesContent":[".StaffPage .grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 32px;\n  max-width: 1000px;\n  margin: 0 auto 0 auto;\n}\n\n@media (max-width: 600px) {\n  .StaffPage .grid {\n    grid-template-columns: 1fr;  \n  }\n}\n\n.StaffPage .grid > div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.StaffPage .review {\n  position: relative;\n  max-width: 380px;\n  text-align: center;\n}\n\n.StaffPage .review i {\n  left: 0;\n  position: absolute;\n  color: var(--dark);\n  opacity: 0.2;\n  font-size: 3em;\n}\n\n.staffHero {\n  text-align: center;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 32px;\n}\n\n.staffBottom {\n  text-align: center;\n  width: calc(100% + 128px);\n  margin-left: -64px;\n  background-color: var(--light);\n  box-shadow: var(--box-shadow);\n  padding: 32px;\n  margin-bottom: 32px;\n}\n\n.staffHero h4 {\n  margin-top: 0px;\n  margin-bottom: 40px;\n}\n\n.staffHero p {\n  margin: 4px;\n}\n\n.staffBottom p {\n  font-size: 1.2em;\n  margin: 0 auto;\n  margin-bottom: 16px;\n  max-width: 260px;\n  text-align: center;\n}\n\n@media (max-width: 950px) {\n  .staffBottom {\n    width: calc(100% + 40px);\n    margin-left: -20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
